module.exports = __webpack_public_path__ + "img/7.b7bb388d.svg";